import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
import { ForecastMoneyCell, ForecastVarianceCell, ForecastPercentCell, ForecastConfidenceCell, ForecastStatusChip, ForecastDeltaClass, ForecastGridSx } from './ForecastGridRenderers';

type Props = { rows:any[]; loading?:boolean; selectedId?:any; onSelect?:(row:any)=>void };

class ForecastModelGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'batchcode', headerName: 'Batch', width: 150 },
    { field: 'sourceyear', headerName: 'Source Year', width: 120 },
    { field: 'targetyear', headerName: 'Target Year', width: 120 },
    { field: 'calculationmode', headerName: 'Mode', width: 150 },
    { field: 'productcode', headerName: 'Product', width: 130 },
    { field: 'metriccode', headerName: 'Metric', width: 150 },
    { field: 'periodcode', headerName: 'Period', width: 120 },
    { field: 'basevalue', headerName: 'Base', width: 140, renderCell: ForecastMoneyCell },
    { field: 'forecastvalue', headerName: 'Forecast', width: 140, renderCell: ForecastMoneyCell },
    { field: 'deltaamount', headerName: 'Delta', width: 140, renderCell: ForecastVarianceCell, cellClassName: ForecastDeltaClass },
    { field: 'deltapercent', headerName: 'Delta %', width: 130, renderCell: ForecastPercentCell, cellClassName: ForecastDeltaClass },
    { field: 'confidence', headerName: 'Confidence', width: 150, renderCell: ForecastConfidenceCell },
    { field: 'status', headerName: 'Status', width: 130, renderCell: ForecastStatusChip },
  ];

  getRowId = (row:any) => row.rid || row.recid || row.id || `${row.batchcode}-${row.sourceyear}-${row.targetyear}-${row.calculationmode}-${row.productcode}-${row.metriccode}-${row.periodcode}`;

  render() {
    return (
      <FDataGrid
        title="Forecast Model Output"
        subtitle="Model-generated forecast rows. Composite row IDs prevent duplicate rendering."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={520}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={this.getRowId}
        onRowClick={(p:any) => this.props.onSelect?.(p.row)}
        pageSizeOptions={[25,50,100]}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        sx={ForecastGridSx}
      />
    );
  }
}

export default ForecastModelGrid;
